const SELECTOR = '[data-fg-nav-tabs]';
const DESKTOP_MEGA_MENU_SELECTOR = 'details[is="mega-menu-disclosure"]';

class FogattiNavigationTabs {
  constructor(root) {
    this.root = root;
    this.tabs = [...root.querySelectorAll('[data-fg-nav-tab]')];
    this.panels = [...root.querySelectorAll('[data-fg-nav-panel]')];

    if (this.tabs.length === 0 || this.tabs.length !== this.panels.length) return;

    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.activate(index));
      tab.addEventListener('mouseenter', () => {
        if (window.matchMedia('(pointer: fine)').matches) this.activate(index);
      });
      tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
    });

    const initiallySelected = Math.max(
      0,
      this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true')
    );

    this.activate(initiallySelected);
    root.dataset.fgNavReady = 'true';
  }

  activate(index, focus = false) {
    if (index !== this.activeIndex) {
      const menu = this.root.closest('.fg-mega-menu');
      if (menu) menu.scrollTop = 0;
      this.activeIndex = index;
    }

    this.tabs.forEach((tab, tabIndex) => {
      const selected = tabIndex === index;
      tab.setAttribute('aria-selected', String(selected));
      tab.tabIndex = selected ? 0 : -1;
      this.panels[tabIndex].hidden = !selected;
    });

    if (focus) this.tabs[index].focus();
  }

  onKeydown(event, currentIndex) {
    const lastIndex = this.tabs.length - 1;
    let nextIndex = currentIndex;

    switch (event.key) {
      case 'ArrowDown':
      case 'ArrowRight':
        nextIndex = currentIndex === lastIndex ? 0 : currentIndex + 1;
        break;
      case 'ArrowUp':
      case 'ArrowLeft':
        nextIndex = currentIndex === 0 ? lastIndex : currentIndex - 1;
        break;
      case 'Home':
        nextIndex = 0;
        break;
      case 'End':
        nextIndex = lastIndex;
        break;
      default:
        return;
    }

    event.preventDefault();
    this.activate(nextIndex, true);
  }
}

function initializeDesktopMegaMenuRecovery(scope = document) {
  scope.querySelectorAll(DESKTOP_MEGA_MENU_SELECTOR).forEach((menu) => {
    if (menu.dataset.fgHoverRecoveryReady === 'true' || !menu.querySelector('.fg-mega-menu')) return;

    let pointerInside = false;
    let recoveryTimer;
    const summary = menu.querySelector(':scope > summary');

    // Impact's hover disclosure cancels the summary's native keyboard click.
    // Keep this correction limited to the Fogatti Products mega menu.
    menu.addEventListener('keydown', (event) => {
      if (event.target === summary && (event.key === 'Enter' || event.key === ' ')) {
        event.preventDefault();
        if (event.repeat) return;
        window.clearTimeout(recoveryTimer);
        window.clearTimeout(menu._hoverTimer);
        menu.open = !menu.open;
        if (menu.open) {
          const firstTab = menu.querySelector('[data-fg-nav-tab]');
          firstTab?.click();
          firstTab?.focus();
        }
      } else if (event.key === 'Escape' && menu.open) {
        event.preventDefault();
        event.stopPropagation();
        window.clearTimeout(recoveryTimer);
        window.clearTimeout(menu._hoverTimer);
        menu.open = false;
        summary?.focus();
      }
    });

    menu.addEventListener('pointerenter', () => {
      if (menu.trigger !== 'hover' || !window.matchMedia('(pointer: fine)').matches) return;

      pointerInside = true;
      window.clearTimeout(recoveryTimer);
      menu.open = true;

      // Impact removes the native open attribute after its closing animation.
      // If the pointer returned during that animation, restore the attribute so
      // the internal state and the rendered menu cannot become desynchronised.
      recoveryTimer = window.setTimeout(() => {
        if (pointerInside && menu.open && !menu.hasAttribute('open')) {
          menu.setAttribute('open', '');
          if (menu.contentElement) menu.contentElement.style.opacity = '1';
        }
      }, 260);
    });

    menu.addEventListener('pointerleave', () => {
      pointerInside = false;
      window.clearTimeout(recoveryTimer);
    });

    menu.dataset.fgHoverRecoveryReady = 'true';
  });
}

function initializeFogattiNavigation(scope = document) {
  initializeDesktopMegaMenuRecovery(scope);

  scope.querySelectorAll(SELECTOR).forEach((root) => {
    if (root.dataset.fgNavReady === 'true') return;
    new FogattiNavigationTabs(root);
  });

  scope.querySelectorAll('.fg-mobile-category').forEach((category) => {
    if (category.dataset.fgAccordionReady === 'true') return;

    category.addEventListener('toggle', () => {
      if (!category.open) return;

      const categoryGroup = category.closest('.fg-mobile-products__categories');
      categoryGroup?.querySelectorAll('.fg-mobile-category[open]').forEach((sibling) => {
        if (sibling !== category) sibling.open = false;
      });
    });

    category.dataset.fgAccordionReady = 'true';
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeFogattiNavigation());
} else {
  initializeFogattiNavigation();
}

document.addEventListener('shopify:section:load', (event) => {
  initializeFogattiNavigation(event.target);
});
